import React from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, chats, onSelectChat, onDeleteChat, currentChatId }) => {
    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            {isOpen && (
                <button className="close-sidebar" onClick={toggleSidebar}>
                    <FaChevronLeft />
                </button>
            )}
            <div className="chat-list">
                {Array.isArray(chats) && chats.length > 0 ? (
                    chats.map((chat) => (
                        chat && chat.id ? (
                            <div
                                key={chat.id}
                                className={`chat-item ${currentChatId === chat.id ? 'active' : ''}`}
                            >
                                <span
                                    onClick={() => onSelectChat(chat.id)}
                                    className="chat-title"
                                >
                                    {chat.title || 'Untitled Chat'}
                                </span>
                                <button
                                    className="delete-chat"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDeleteChat(chat.id);
                                    }}
                                    aria-label="Delete chat"
                                >
                                    ×
                                </button>
                            </div>
                        ) : null
                    ))
                ) : (
                    <div className="no-chats">No chats yet</div>
                )}
            </div>
        </div>
    );
};

export default Sidebar;